import type { CancelSubscriptionReasonId } from "./cancel-reasons";

export type RetentionOffer = "delay" | "change_frequency";

// The ordered retention offers shown (one per sub-step) for a post-2nd-shipment
// cancel reason. Unavailable offers are omitted so the caller can skip straight
// to the cancel confirm when nothing is left to offer.
export function buildRetentionOfferSequence(
  reasonId: CancelSubscriptionReasonId,
  opts: {
    delayAvailable: boolean;
    changeFrequencyAvailable: boolean;
  },
): RetentionOffer[] {
  const delay: RetentionOffer[] = opts.delayAvailable ? ["delay"] : [];
  const changeFrequency: RetentionOffer[] = opts.changeFrequencyAvailable
    ? ["change_frequency"]
    : [];
  switch (reasonId) {
    case "too_much_product":
    case "dont_use_as_much":
    case "other":
      return [...delay, ...changeFrequency];
    case "cant_afford":
      // Change-frequency leads when cost is the issue (same price per delivery,
      // billed less often → lower monthly spend); delay is the fallback.
      return [...changeFrequency, ...delay];
    case "prefer_to_order_on_own":
      // Change-frequency leads (order on your own schedule = fewer, spaced-out
      // deliveries); delay is the fallback. Deliberately change-frequency-first,
      // unlike the delay-first cases above.
      return [...changeFrequency, ...delay];
    default:
      // All pre-2nd-shipment reasons never reach here.
      return [];
  }
}
